export default {"src":"/_next/static/media/uma.c1ab62ef.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};